import { useCallback } from 'react';

import { useCreateTwilioAccount } from '../../../../modules/TwilioAccounts/twilio-accounts.api';
import { getApiErrorMessage } from '../../../../utils/Api';
import { useToasterContext } from '../../../common/Toaster';
import { AppSettingsFormValues } from '../AppSettingsForm';

export const useCreateNewTwilioAccount = () => {
  const { showError } = useToasterContext();
  const { mutateAsync: createTwilioAccount } = useCreateTwilioAccount();

  const createNewTwilioAccount = useCallback(
    async ({ twilioAccountSid, twilioAccountAuthToken }: AppSettingsFormValues) => {
      try {
        const { twilioAccountId } = await createTwilioAccount({
          sid: twilioAccountSid,
          authToken: twilioAccountAuthToken,
        });
        return twilioAccountId;
      } catch (error: any) {
        showError(getApiErrorMessage(error));
        throw error;
      }
    },
    [createTwilioAccount, showError],
  );

  return createNewTwilioAccount;
};
